"use client";
import './assets/Input.css';const _ = "_name_1mgti_1", t = "__center_1mgti_9", n = "_label_1mgti_13", o = "_input_1mgti_16", i = "__loading_1mgti_16", e = "__disabled_1mgti_16", a = "_icon_1mgti_20", c = "_icon__ok_1mgti_31", r = "_icon__reset_1mgti_31", s = "_normal_1mgti_57", g = "_textarea_1mgti_65", m = "_large_1mgti_74", l = "_icon__main_1mgti_104", d = "_datacopy_1mgti_108", p = "_rotation_1mgti_1", x = "__error_1mgti_144", b = "__active_1mgti_167", y = "_textarea_lenght_1mgti_176", h = {
  name: _,
  _center: t,
  label: n,
  input: o,
  _loading: i,
  _disabled: e,
  icon: a,
  icon__ok: c,
  icon__reset: r,
  normal: s,
  textarea: g,
  large: m,
  icon__main: l,
  datacopy: d,
  rotation: p,
  _error: x,
  _active: b,
  textarea_lenght: y
};
export {
  h as s
};
